module.exports = __webpack_public_path__ + "img/1DX_0296.fd7deaca.jpg";